<template>
    <div class="message-item__content--table">
        <div class="table" @click="clickLink">
            <img
                v-if="url"
                :src="url"
                :style="{
                    width: `${totalWidth}px`
                }"
                class="table__snapshot viewer"
                @click="previewImage" />
            <table
                v-else
                ref="table"
                :style="{
                    width: isMobile ? `${totalWidth}px` : 'auto'
                }">
                <tr v-for="(tr, trIndex) in newtable"
                    :key="trIndex">
                    <td v-for="(td, tdIndex) in tr"
                        :key="tdIndex"
                        :class="{       
                            'acolor': showcolor
                        }"
                        :style="{
                            width: `${colWidths[tdIndex]}px`
                        }" v-html="td">
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import domtoimage from 'dom-to-image'
    import { getTextWidth } from '@/utils'
    import previewImageMixin from '../../mixins/preview_image'

    const DEFAULT_DEVICE_PIXEL_RATIO = 2

    export default {
        name: 'MessageContentTable',
        mixins: [
            previewImageMixin
        ],
        props: {
            table: {
                type: Array,
                required: true
            },
            server: {
                type: Object
            }
        },
        data () {
            return {
                DEFAULT_DEVICE_PIXEL_RATIO,
                url: ''
            }
        },
        computed: {
            newtable () {
                this.table.forEach((fval)=>{
                    if(fval) {
                        fval.forEach((context, index)=>{
                            if (context) {
                                //先匹配字串中的a标签
                                let patt = /<a\b.*?<\/a>/g
                                let contextarr = context.match(patt)
                                if(contextarr) {
                                    for (let i = 0; i < contextarr.length; i++) {
                                        //标签没有target
                                        if (contextarr[i].indexOf('target') == -1) {
                                            //item在字串中的位置
                                            let strindex = context.indexOf(contextarr[i])
                                            //为a标签添加target属性
                                            let newresult = contextarr[i].replace('>', ' target="_blank">')
                                            let contextstr = context.substr(strindex, contextarr[i].length)
                                            fval[index] = context.replace(contextstr, newresult)
                                        }
                                    }
                                }
                            }
                        })
                    }
                })
                return this.table
            },
            isMobile () {
                return this.$eventBus.isMobile
            },
            colWidths () {
                const result = []
                const table = this.table
                const FONT_SIZE = 12
                const PADDING_SIZE = 20
                const SCALE = 1.1
                const WIDTH_MAX = 10 * FONT_SIZE + PADDING_SIZE // 10个字

                for (let colIndex = 0, colLen = table[0].length; colIndex < colLen; colIndex++) {
                    let maxWidth = getTextWidth(table[0][colIndex], FONT_SIZE)
                    for (let rowIndex = 1, rowLen = table.length; rowIndex < rowLen; rowIndex++) {
                        const cell = table[rowIndex][colIndex]
                        const cellWidth = getTextWidth(cell, FONT_SIZE)
                        if (cellWidth > maxWidth) {
                            maxWidth = cellWidth
                        }
                    }
                    const actualWidth = Math.ceil((maxWidth + PADDING_SIZE) * SCALE)
                    result.push(Math.min(actualWidth, WIDTH_MAX))
                }

                return result
            },
            totalWidth () {
                return this.colWidths.reduce((acc, cur) => {
                    return acc + cur
                })
            },
            showcolor () {
                if (this.server && this.server.from) {
                    if (this.server.from == 'robot' || this.server.from == 'user') {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            }
        },
        methods: {
            clickLink (event) {
                if (event.target.tagName === 'A') {
                    event.stopPropagation()
                }
            },
            async toImg () {
                try {
                    // 经测试，对于该案例 toPng 比 toJpeg 小（base64）
                    // domtoimage 高清问题：https://github.com/tsayen/dom-to-image/issues/69#issuecomment-486146688
                    const $node = this.$refs.table
                    const scale = DEFAULT_DEVICE_PIXEL_RATIO
                    const nodeWidth = $node.offsetWidth
                    const nodeHeight = $node.offsetHeight
                    return await domtoimage.toPng($node, {
                        height: nodeHeight * scale,
                        width: nodeWidth * scale,
                        style: {
                            transform: 'scale(' + scale + ')',
                            transformOrigin: 'top left',
                            width: nodeWidth + 'px',
                            height: nodeHeight + 'px'
                        }
                    })
                } catch (err) {
                    // eslint-disable-next-line
                    console.error(err)
                }
            }
        },
        async mounted () {
            if (this.isMobile) {
                this.url = await this.toImg()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .message-item__content--table {
        display: inline-block;
        padding: 10px;
        background-color: #ffffff;
        vertical-align: top;
        max-width: 100%;
        @include radius(.25, .5, .5, .5);
    }

    .table {
        width: calc(100% + 1px);
        height: 100%;
        overflow: auto;

        &__snapshot {
            width: 100%;
            height: 100%;
        }
    }

    table {
        border-collapse: collapse;
        background-color: #ffffff;
        table-layout: fixed;

        @include desktop {
            width: 540px !important;
        }
    }

    td {
        color: #333;
        padding: 6px 10px;
        border: 1px solid #d1d1d1;
        font-size: 12px;

        @include desktop {
            font-size: 14px;
        }
    }
    /deep/ a{
        color: #fff;
        &:hover{
            color:#fff;
        }
    }
    .acolor {
        /deep/ a{
            color: #0068FF;
            &:hover{
                color:#0068FF;
            }
        }
    }
</style>
